<template>
  <MDBToast
    :class="['spa-toast', `${props.variant}`, `${props.color}`]"
    :position="props.position"
    appendToBody
    stacking
    offset="16"
    v-bind="$attrs"
  >
    <template #title>
      <span
        v-if="props.variant != 'default'"
        class="SproutIcon icon-status"
        :class="statusIcon"
      ></span>
      <slot name="title"></slot>
    </template>
    <p>
      <slot name="description"></slot>
      <slot></slot>
    </p>
  </MDBToast>
</template>
<style lang="scss">
// Because of its appendToBody nature, it cannot be scoped.
.spa-toast {
  width: 424px !important;
  background: $neutral-0 !important;
  border-radius: 2px !important;
  padding-block: 16px;
  padding-right: 16px;
  padding-left: 16px;

  .toast-header {
    background-color: unset;
    border-bottom: 0;
    padding-inline: 0;
    padding-top: 0;
    padding-bottom: 8px;
    align-items: flex-start;

    strong {
      display: flex;
      gap: 16px;
      font-weight: 500 !important;
      font-size: 16px;
      line-height: 24px;
      color: $neutral-800;
    }
  }
  .toast-body {
    padding: 0;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    color: $neutral-800;
  }

  &.warning,
  &.error,
  &.info,
  &.success {
    .icon-status {
      font-size: 24px;
      line-height: 24px;
    }
    .toast-body {
      padding-left: 40px;
    }
  }

  &.warning {
    box-shadow:
      0px 2px 6px rgba(82, 86, 71, 0.15),
      inset 4px 0px 0px $yellow-300;
    .icon-status {
      color: $yellow-300;
    }
  }
  &.error {
    box-shadow:
      0px 2px 6px rgba(82, 86, 71, 0.15),
      inset 4px 0px 0px $red-300;
    .icon-status {
      color: $red-300;
    }
  }
  &.info {
    box-shadow:
      0px 2px 6px rgba(82, 86, 71, 0.15),
      inset 4px 0px 0px $blue-300;
    .icon-status {
      color: $blue-300;
    }
  }
  &.success {
    box-shadow:
      0px 2px 6px rgba(82, 86, 71, 0.15),
      inset 4px 0px 0px $green-300;
    .icon-status {
      color: $green-300;
    }
  }

  &.dark {
    background-color: $neutral-900 !important;
    color: $neutral-0 !important;
    border-radius: 4px !important;
    max-width: 344px !important;

    .toast-header {
      display: none;
    }
    p {
      font-size: 16px;
      color: $neutral-0;
    }
  }
}
</style>
<script>
import { computed } from 'vue';
import { MDBToast } from 'mdb-vue-ui-kit';
export default {
  name: 'SPAToast',
  components: { MDBToast },
  props: {
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'warning', 'error', 'info', 'success'].includes(
          value,
        );
      },
    },
    position: {
      type: String,
      default: 'top-right',
      validator(value) {
        return [
          'top-right',
          'top-left',
          'bottom-center',
          'bottom-left',
        ].includes(value);
      },
    },
    color: {
      type: String,
      default: '',
      validator(value) {
        return ['dark', 'light', ''].includes(value);
      },
    },
  },
  setup(props) {
    const statusIcon = computed(() => {
      if (props.variant === 'warning') {
        return 'SproutIcon-warning-solid';
      }
      if (props.variant === 'error') {
        return 'SproutIcon-error-solid';
      }
      if (props.variant === 'info') {
        return 'SproutIcon-information-solid';
      }
      if (props.variant === 'success') {
        return 'SproutIcon-success-solid';
      }
      return '';
    });
    return { props, statusIcon };
  },
};
</script>
